import { lazy } from 'react';
import { type RouteObject } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';

const DeletePage = lazy(() => import('./pages/delete'));
const EditPage = lazy(() => import('./pages/edit'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/webshops',
    title: 'Webshopovi',
    Component: IndexPage,
    children: [{
        Component: ModalOutlet,
        children: [{
            path: 'add',
            Component: EditPage,
        }],
    }, {
        path: ':webshopId',
        Component: ModalOutlet,
        children: [{
            path: 'delete',
            Component: DeletePage,
        }, {
            path: 'edit',
            Component: EditPage,
        }]
    }],
} satisfies RouteObject;
